import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../../generic-components/Heading';
import { ReactComponent as CategorizationLogo } from '../../../../../assets/dashboard/categorization-logo.svg';

const testIdPrefix = 'CategorizationZeroState';

export const CategorizationZeroState = () => {
  const { t } = useTranslation();
  return (
    <div className='relative z-10 mt-[75px]'>
      <CategorizationLogo className='mx-auto h-[124px] w-[160px]' data-testid={`${testIdPrefix}__logo`} />
      <Heading title={t('CATEGORIZATION_ZERO_STATE.SUBTITLE')} className='font-metricR text-sm text-bw08 w-[215px] leading-5 text-center mt-[14px]' testId={`${testIdPrefix}__subtitle`} />
    </div>
  );
};
